import { useMemo } from 'react'
import _ from 'lodash'

/**
 * Hook to get country options from search field data
 * @param {Object} searchFieldData - Search field data containing countries
 * @returns {Array} Array of country options with label and value
 */
export const useCountryOptions = (searchFieldData) => {
  return useMemo(() => {
    return _.sortBy(searchFieldData?.data?.countries, 'name')?.map((item) => ({
      label: item.name,
      value: item.code
    }))
  }, [searchFieldData])
}
